<template>
  <div
    header="操作记录"
    class="operation-record"
  >
    <div class="operationTitle">
      <span>操作时间</span>
      <span>操作人</span>
      <span>操作内容</span>
    </div>
    <div>
      <ul class="operationData">
        <li v-for="(item,index) in data" :key="index">
          <span>{{item.createTime}}</span>
          <span>{{item.user}}</span>
          <span>{{item.operateLog}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination';
import { getLog } from '@/api/accident/edit';
export default {
  components: { Pagination },
  props: {
    accidentId: {
      type: String,
    },
  },
  data() {
    return {
      data: [],
    };
  },

  methods: {
    async getLog() {
      const { data } = await getLog({
        accidentId: this.accidentId
      })
      if (data && data.length) {
        this.data = data
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.operation-record {
  width: 460px;
  height: 420px;
  overflow-x: hidden;
  overflow-y: auto;
  .operationTitle {
    width: 460px;
    height: 60px;
    background: rgba(2, 133, 216, .1);
    border-radius: 8px 8px 0px 0px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 15px;
    color: #7CAFFF;
    text-align: center;
    span {
      width: 33%;
    }
  }
  .operationData {
    padding: 0;
    margin: 0;
    li {
      width: 100%;
      height: 60px;

      list-style: none;
      font-size: 14px;
      color: #B1E3FF;
      text-align: center;
      display: flex;
      justify-content: space-around;
      align-items: center;
      border-bottom: 1px solid rgba(0, 132, 255, .3);
      span {
        width: 33%;
      }
    }
  }
}
</style>

